import { districtState } from '@/app/model/store/domain/types.ts'

export default <districtState> {
  districtData: [],
  searchText: '',
  sortName: 'created_at',
  sortAsc: false
}
